<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.5" height="20.5" viewBox="0 0 20.5 20.5" class="add-icon-simple">
    <g transform="translate(0.25 0.25)">
      <path :style="{fill:color}" class="a" d="M2,12A10,10,0,1,1,12,22,10,10,0,0,1,2,12ZM12,4a8,8,0,1,0,8,8A8,8,0,0,0,12,4Z"
            transform="translate(-2 -2)"/>
      <path :style="{fill:color}" class="a" d="M13,7a1,1,0,0,0-2,0v4H7a1,1,0,0,0,0,2h4v4a1,1,0,0,0,2,0V13h4a1,1,0,0,0,0-2H13Z"
            transform="translate(-2 -2)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AddIconSimple",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: #8ea2a8;
  stroke: #fff;
  stroke-width: 0.5px;
  fill-rule: evenodd;
}
</style>
